/* MELLER x All Points East landing — sale countdown and front-end purchase cap.

   Promotional window: the section renders absolute epochs for both ends
   (resolved server-side from Madrid local time), so the client only ever
   subtracts two timestamps. At the start the countdown is removed and the button
   it was holding back is released; at the end the button closes again regardless
   of remaining stock. Either way a visitor already sitting on the page does not
   have to reload.

   Purchase cap: /cart/add has no per-variant limit, and the server-rendered page
   can be stale (browser cache, back/forward navigation), so the cart is re-read
   on every click. Under the cap: add one and go to the cart. At or over it: just
   go to the cart, without adding. */
(function () {
    var forms = document.querySelectorAll('[data-ape-buy]');
    var countdowns = document.querySelectorAll('[data-ape-countdown]');
    if (!forms.length && !countdowns.length) {
        return;
    }

    function root() {
        var shopify = window.Shopify;
        if (shopify && shopify.routes && shopify.routes.root) {
            return shopify.routes.root;
        }
        return '/';
    }

    /* ---------------- Sale countdown ---------------- */

    // Release every button that was disabled purely by the countdown. Buttons
    // held for being sold out or off-market carry no marker and stay disabled.
    function openSale() {
        var locked = document.querySelectorAll('[data-presale-locked]');
        Array.prototype.forEach.call(locked, function (button) {
            var form = button.closest('[data-ape-buy]');
            var label = form && form.getAttribute('data-buy-label');
            if (label) {
                button.textContent = label;
            }
            button.disabled = false;
            button.removeAttribute('data-presale-locked');
        });
    }

    function setupCountdown(element) {
        var deadline = parseInt(element.getAttribute('data-deadline'), 10);
        if (!deadline) {
            element.remove();
            return;
        }

        var slots = {};
        Array.prototype.forEach.call(
            element.querySelectorAll('[data-unit]'),
            function (node) {
                slots[node.getAttribute('data-unit')] = node;
            }
        );

        var timer = null;

        function pad(value) {
            return value < 10 ? '0' + value : String(value);
        }

        function tick() {
            var left = deadline - Math.floor(Date.now() / 1000);

            if (left <= 0) {
                clearInterval(timer);
                element.remove();
                openSale();
                return;
            }

            var days = Math.floor(left / 86400);
            if (slots.days) slots.days.textContent = pad(days);
            if (slots.hours) slots.hours.textContent = pad(Math.floor(left / 3600) % 24);
            if (slots.minutes) slots.minutes.textContent = pad(Math.floor(left / 60) % 60);
            if (slots.seconds) slots.seconds.textContent = pad(left % 60);
        }

        tick();
        timer = setInterval(tick, 1000);
    }

    Array.prototype.forEach.call(countdowns, setupCountdown);

    if (!forms.length) {
        return;
    }

    // The promotional window closes on its own schedule: stock is irrelevant, so
    // a button with units left still shuts at the end date. Buttons already held
    // by the market gate keep their own copy — closing is not their reason.
    function markEnded(form) {
        if (form.getAttribute('data-market-ok') !== 'true') {
            return;
        }
        var button = form.querySelector('button[type="submit"]');
        if (!button) {
            return;
        }
        var label = form.getAttribute('data-ended-label');
        if (label) {
            button.textContent = label;
        }
        button.disabled = true;
        button.removeAttribute('data-presale-locked');
    }

    function scheduleClose(form) {
        var endTs = parseInt(form.getAttribute('data-sale-end'), 10);
        if (!endTs) {
            return;
        }

        var msLeft = endTs * 1000 - Date.now();
        if (msLeft <= 0) {
            // Already past it — the server rendered the closed state anyway.
            markEnded(form);
            return;
        }

        // setTimeout overflows past 2^31-1 ms and would fire immediately, so
        // anything beyond ~24 days is left alone; nobody holds a tab that long.
        if (msLeft <= 2147483647) {
            setTimeout(function () {
                markEnded(form);
            }, msLeft);
        }
    }

    // /cart/add.js rejects an out-of-stock add with 422. Say so on the button
    // instead of navigating to a cart that never received the ticket.
    function markUnavailable(form) {
        var button = form.querySelector('button[type="submit"]');
        if (!button) {
            return;
        }
        var label = form.getAttribute('data-sold-out-label');
        if (label) {
            button.textContent = label;
        }
        button.disabled = true;
    }

    Array.prototype.forEach.call(forms, function (form) {
        scheduleClose(form);

        form.addEventListener('submit', function (event) {
            var variantId = parseInt(form.getAttribute('data-variant-id'), 10);
            var max = parseInt(form.getAttribute('data-max-per-order'), 10);
            var cartUrl = form.getAttribute('data-cart-url') || root() + 'cart';

            // No cap configured, or no variant: let the plain form post through.
            if (!variantId || !max || max < 1) {
                return;
            }

            event.preventDefault();

            var button = form.querySelector('button[type="submit"]');
            if (button) {
                button.disabled = true;
            }

            fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
                .then(function (response) {
                    return response.json();
                })
                .then(function (cart) {
                    var inCart = 0;
                    (cart.items || []).forEach(function (item) {
                        if (item.variant_id === variantId) {
                            inCart += item.quantity;
                        }
                    });

                    if (inCart >= max) {
                        window.location.href = cartUrl;
                        return null;
                    }

                    return fetch(root() + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                        },
                        body: JSON.stringify({
                            items: [{ id: variantId, quantity: 1 }],
                        }),
                    }).then(function (response) {
                        // Rejected adds are almost always the last ticket going
                        // between page load and click, so surface it here rather
                        // than sending the shopper to an unchanged cart.
                        if (!response.ok) {
                            markUnavailable(form);
                            return;
                        }
                        window.location.href = cartUrl;
                    });
                })
                .catch(function () {
                    // Network trouble: fall back to the plain form submit, which
                    // bypasses this handler.
                    if (button) {
                        button.disabled = false;
                    }
                    form.submit();
                });
        });
    });
})();
